import styled from 'styled-components';

const ListItem = styled.li`
    margin: 0;
    line-height: 25px;
`
export default ListItem;


// WEBPACK FOOTER //
// ./src/components/Footer/ListItem.js